import {IRange} from "@pg-design/inputs-module";
import {apiPath} from "@pg-mono/rp-api-routes";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

export interface IClientPayload {
    email: string;
    area?: IRange<number>;
    financing_services?: boolean;
    loan_installment?: IRange<number>;
    marketing_consent?: boolean;
    name?: string;
    phone?: string;
    price?: IRange<number> | null;
    regions?: number[];
    rooms?: IRange<number>;
    types?: number[];
    distance?: number;
    additional_areas?: number[];
    comments?: string;
    construction_end_date?: ConstructionEndDateType;
    floors?: ForYouFloorChoiceType[];
    kitchen_type?: number;
    quarters?: number[];
    survey_source?: PreferencesSurveySource;
    system_comments?: string;
    no_hm_enable?: boolean;
    explicit_submit?: boolean;
}

export type IClientUpdatePayload = Partial<IClientPayload>;

export const forYouClient = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createForYouClient: build.mutation<unknown, IClientPayload>({
            query: (params) => {
                return {
                    url: apiPath.applications.client.create,
                    method: "POST",
                    body: params
                };
            }
        }),
        updateForYouClient: build.mutation<unknown, IClientUpdatePayload>({
            query: (params) => {
                return {
                    url: apiPath.applications.client.update,
                    method: "PATCH",
                    body: params
                };
            }
        })
    })
});

export const {useCreateForYouClientMutation, useUpdateForYouClientMutation} = forYouClient;
